import { defineComponent } from 'vue';

import type {
	VisibilityChangedPayload,
	BatchImpressionTrackingOptions,
} from '@/helpers/composables/useBatchImpressionTracking';
import { useBatchImpressionTracking } from '@/helpers/composables/useBatchImpressionTracking';

import type { ObjectType } from '@/@types/graphql-types';
import type { TitleContentType } from '@/interfaces/snowplow/title-context';
import { SnowplowTitleContextGraphql } from '@/helpers/tracking/providers/snowplow-contexts';

export type PosterVisibilityChangedPayload = VisibilityChangedPayload<any>;
export interface ImpressionTrackingPosterDetails {
	titleId: number;
	objectType: ObjectType;
	seasonNumber?: number;
	episodeNumber?: number;
	contentType?: TitleContentType;
}

export function usePosterImpressionTracking(options: BatchImpressionTrackingOptions) {
	return useBatchImpressionTracking<ImpressionTrackingPosterDetails>({
		category: 'title',
		toContext: getPosterImpressionContext,
		...options,
	});
}

/** Renderless version */
export default defineComponent({
	name: 'UsePosterImpressionTracking',
	setup(props: BatchImpressionTrackingOptions, { slots }) {
		return () => slots.default?.(usePosterImpressionTracking(props)) ?? slots[0];
	},
});

function getPosterImpressionContext({
	titleId,
	objectType,
	seasonNumber,
	episodeNumber,
	contentType,
}: ImpressionTrackingPosterDetails): SnowplowTitleContextGraphql {
	return new SnowplowTitleContextGraphql(titleId, objectType, seasonNumber, episodeNumber, contentType);
}
